import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {login} from '../actions/user'
import {Container, Row, Col, CardGroup, Card, CardBody, InputGroup, InputGroupAddon} from 'reactstrap'
import gql from 'graphql-tag'
import {graphql} from 'react-apollo'

export class Login extends Component {

  constructor(props) {
    super(props)
    this.state = {
      email: '', password: '', error: ''
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  static propTypes = {
    login: PropTypes.func.isRequired,
    mutate: PropTypes.func.isRequired
  }

  handleInputChange(event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    this.setState({
      [name]: value
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    event.stopPropagation()

    this.props.mutate({
      variables: {email: this.state.email, password: this.state.password}
    }).then(({data: {signInUser}}) => {
      if (signInUser.errors && signInUser.errors.length > 0) {
        return this.setState({error: signInUser.errors.join(', ')})
      }

      if (signInUser.token) {
        this.props.login({
          id: signInUser.user.id,
          email: signInUser.user.email,
          auth_token: signInUser.token,
          refresh_token: signInUser.refresh_token,
          permissions: JSON.parse(signInUser.user.permissions),
          person_id: signInUser.user.person_id
        })
      }
    }).catch(() => {
      this.setState({error: 'there was an error sending the query'})
    })
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card style={{width: '50%'}}>
                  <CardBody className='row h-100'>
                    <form onSubmit={this.handleSubmit} className="login-form col-sm-12 my-auto">
                      <h1>Login</h1>
                      <p className="text-muted">Sign In to your account</p>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <i className="icon-user input-group-text"/>
                        </InputGroupAddon>
                        <input type="text" placeholder="e-mail" name="email" onChange={this.handleInputChange}/>
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <i className="icon-lock input-group-text"/>
                        </InputGroupAddon>
                        <input type="password" placeholder="Password" name="password"
                          onChange={this.handleInputChange}/>
                      </InputGroup>
                      <Row className="mb-4">
                        {this.state.error}
                      </Row>
                      <Row>
                        <Col xs="6">
                          <input type="submit" value="Login" className="px-4 btn btn-primary"/>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Card>
                <Card style={{width: '50%'}}>
                  <img alt='weldinGo' width='100%' height='100%' src={process.env.PUBLIC_URL +'/weldingo.jpg'}/>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

const signInUserQuery = gql`
  mutation signInUser($email: String!, $password: String!) {
    signInUser(email: {email: $email, password: $password}) {
      token
      refresh_token
      user {
        id
        email
        permissions
        person_id
      }
      errors
    }
  }
`

const LoginWithData = graphql(signInUserQuery)(Login)

export default connect(null, {login})(LoginWithData)



// WEBPACK FOOTER //
// ./src/containers/Login.js